export const ADD_IN_USER = 'ADD_IN_USER';
export const ADD_IN_USER_SUCCESS = 'ADD_IN_USER_SUCCESS';
export const ADD_IN_USER_ERROR = 'ADD_IN_USER_ERROR';
export const DELETE_USER = 'DELETE_USER';